import React from 'react';
import { Outlet } from 'react-router-dom';
import { generatePDF } from '../../../shared/tools';
import { useSelectedMenu } from '../../../shared/utils/calculatorMenu';
import { useCalculatorNavigate } from '../../../shared/utils/calculatorNavigate';
import { calculatorParams, MenuType } from '../CalculatorParams';

export function CalculatorOutlet(): JSX.Element {
    const calculatorWithPrefixNavigate = useCalculatorNavigate();
    const calculatorNavigate = useCalculatorNavigate({disablePrefix: true});

    return <>

        <header>

            <section>

                <div className="container" onClick={() => calculatorNavigate('/home')}>
                    <img src='/assets/img/logo-gehealthcare.svg' alt='logo gehealthcare'/>
                    {calculatorParams.label}
                </div>

            </section>

            <section>

                <nav className="container">
                    <a className={useSelectedMenu<MenuType>('home') ? 'is-active' : ''}
                       onClick={() => calculatorWithPrefixNavigate('home')}
                       title="CalculatorHome">
                        <img src='/assets/icons/home.svg'
                             alt='home'/><span>CalculatorHome</span>
                    </a>
                    <a className={useSelectedMenu<MenuType>('economical') ? 'is-active' : ''}
                       onClick={() => {
                           calculatorWithPrefixNavigate('economical');
                       }}
                       title="Economical impact of a system hard down or in limited use">
                        <img src='/assets/icons/economic.svg'
                             alt='Economical impact of a system hard down or in limited use'/><span>Economical impact of a system hard down or in limited use</span>
                    </a>
                    <a className={useSelectedMenu<MenuType>('resources') ? 'is-active' : ''}
                       onClick={() => calculatorWithPrefixNavigate('resources')}
                       title="resources">
                        {/*<img src='/assets/icons/file.svg'*/}
                        {/*     alt='resources'/><span>Resources</span>*/}
                    </a>
                    <a onClick={() => generatePDF('download')} title="download"><img
                        src='/assets/icons/download.svg' alt='download'/></a>
                    <a onClick={() => generatePDF('print')} title="print"><img
                        src='/assets/icons/print.svg'
                        alt='print'/></a>
                </nav>

            </section>

        </header>

        <main className="container">

            <Outlet/>

            <section>

                <article className="disclaimer">

                    <h1>Legal Disclaimer</h1>

                    <p>This information is hypothetical.</p>

                    <p>Information presented in this tool is hypothetical and for illustrative
                        purposes
                        only. Any
                        analysis
                        or information derived from this tool is for general information purposes
                        only
                        and
                        is being
                        furnished to you free of charge and without any representation or warranty
                        of
                        any
                        kind
                        whatsoever,
                        including with respect to the calculations, inputs, outputs, and/or
                        information
                        provided in such
                        analysis. While this tool allows several variables to be entered, this tool
                        also
                        contains
                        certain
                        assumptions that may not be valid for your specific facts and circumstances.
                        This
                        tool and any
                        analysis are provided for your use only and may not be transferred to any
                        third
                        party.</p>

                    <p>You must independently verify this information and seek expert advice.</p>

                </article>

            </section>

        </main>

        <footer>
            <section className="container">
                <div>
                    <img src="/assets/img/logo-gehealthcare-couleur.svg"
                         alt='logo gehealthcare couleur'/>
                    <span>© {new Date().getFullYear()} General Electric Company - All rights reserved</span>
                    <span>GE and GE monogram are trademarks of General Electric Company</span>
                    <span>GE Healthcare a division of General Electric Company</span>
                </div>
                <div>JB31580XX</div>
            </section>
        </footer>

    </>
        ;
}
